// extracted by mini-css-extract-plugin
module.exports = {"link":"_1qIp8","image":"_392LO","root":"_1o-bz"};